import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import Layout from "./pages/Layout";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import MyProfile from "./pages/MyProfile";
import Landing from "./pages/Landing";
import CompanySignup from "./pages/CompanySignup";
import SuperadminSignIn from "./pages/SuperadminSignin";
import SuperadminDashboard from "./pages/superadmin/SuperadminDashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  superadminLogin,
  superadminLogout,
} from "./store/superadminAuth.slice";
import { useEffect, useState } from "react";
import { SERVER_URL } from "./constant";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import EmployeeSignin from "./pages/EmployeeSignin";
import { employeeLogin, employeeLogout } from "./store/employeeAuth.slice";
import EmpoloyeeOnboardingForm from "./pages/EmpoloyeeOnboardingForm";
import Attendance from "./pages/Attendance";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LeaveApplications from "./pages/LeaveApplications";
import EmployeeSalary from "./pages/EmployeeSalary";
import EmployeeDocuments from "./pages/EmployeeDocuments";
import EmployeeHRDocument from "./pages/EmployeeHRDocument";
import AddAdmin from "./pages/superadmin/AddAdmin";
import AllEmployees from "./pages/superadmin/AllEmployees";
import OneEmployee from "./pages/OneEmployee";
import RoleSettings from "./pages/superadmin/RoleSettings";
import OnboardingEmployee from "./pages/admin/OnboardingEmployee";
import SalaryStructure from "./pages/admin/SalaryStructure";
import ProjectAssign from "./pages/admin/ProjectAssign";
import OnboardedEmployees from "./pages/admin/OnboardedEmployees";
import EditOnboardingEmployee from "./pages/admin/EditOnboardingEmployee";
import LeaveManagement from "./pages/admin/LeaveManagement";
import Notification from "./pages/Notification";
import LeaveApproval from "./pages/admin/LeaveApproval";
import MyLeaveApplication from "./pages/MyLeaveApplication";
import AdminLeaveApplications from "./pages/admin/AdminLeaveApplications";
import AttendanceRequest from "./pages/admin/AttendanceRequest";
import TeamMembers from "./pages/admin/TeamMembers";
import MemberProfile from "./pages/admin/MemberProfile";
import CompanyGoalManagement from "./pages/admin/CompanyGoalManagement";
import EmployeeGoalSettings from "./pages/admin/EmployeeGoalSettings";
import EmployeeManagement from "./pages/admin/EmployeeManagement";
import EmployeeHrDocumentManagement from "./pages/admin/EmployeeHrDocumentManagement";
import PolicyManagement from "./pages/admin/PolicyManagement";
import EmployeeTickets from "./pages/EmployeeTickets";
import TicketManagement from "./pages/admin/TicketManagement";
import SAOnboardingEmployee from "./pages/superadmin/SAOnboardingEmployee";
import AllAttedance from "./pages/admin/AllAttedance";
import SingleEmployee from "./pages/admin/SingleEmployee";
import PayslipManagement from "./pages/admin/PayslipManagement";
import CompanySettings from "./pages/admin/CompanySettings";
import LetterGenerate from "./pages/admin/LetterGenerate";
import OfferLetter from "./pages/admin/OfferLetter";
import SAResetPassword from "./pages/superadmin/SAResetPassword";
import EmployeeForgotPassword from "./pages/EmployeeForgotPassword";
import EditEmployee from "./pages/admin/EditEmployee";
import TextLetterGenerate from "./pages/admin/TextLetterGenerate";
import TalentAquisation from "./pages/admin/TalentAquisation";
import HiringReqOptions from "./pages/admin/HiringReqOptions";
import NewHiringReq from "./pages/admin/NewHiringReq";
import AllHiringReq from "./pages/admin/AllHiringReq";
import TAHiringReqAll from "./pages/admin/TAHiringReqAll";
import TASingleHiringReq from "./pages/admin/TASingleHiringReq";
import SingleJobApplicant from "./pages/admin/SingleJobApplicant";
import SingleHiringReqManager from "./pages/admin/SingleHiringReqManager";
import ApplicantListManager from "./pages/admin/ApplicantListManager";
import SingleJobApplicantManager from "./pages/admin/SingleJobApplicantManager";
import LetterHistory from "./pages/admin/LetterHistory";
import FinalRoundShortlisted from "./pages/admin/FinalRoundShortlisted";
import SingleCompOffRecord from "./pages/admin/SingleCompOffRecord";
import CompOffRecordAll from "./pages/admin/CompOffRecordAll";
import SingleCompOffRecordEmployee from "./pages/SingleCompOffRecordEmployee";
import AddAndEditLetter from "./pages/admin/AddAndEditLetter";
import AllSavedTemplates from "./pages/admin/AllSavedTemplates";
import EditTemplate from "./pages/admin/EditTemplate";
import SingleProjectPage from "./pages/admin/SingleProjectPage";
import ManagerProjects from "./pages/admin/ManagerProjects";
import SingleProjectPageManager from "./pages/admin/SingleProjectPageManager";
import NotificationManagement from "./pages/admin/NotificationManagement";

function App() {
  const isSuperadmin = useSelector(
    (state) => state.superadmin?.isSuperadminAuthenticated
  );
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const isReload = useSelector((state) => state.reload?.reload);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [rawEmployeeData, setRawEmployeeData] = useState({});

  async function getSuperadmin() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/get-superadmin`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      dispatch(superadminLogin({ data: res.data?.data }));
    } catch (error) {
      //console.log(error);
      dispatch(superadminLogout());
    } finally {
      setLoading(false);
    }
  }

  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/user/employee`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setRawEmployeeData(res.data?.data);
      dispatch(employeeLogin({ data: res.data?.data }));
    } catch (error) {
      console.log(error);
      dispatch(employeeLogout());
    } finally {
      setLoading(false);
    }
  }

  //console.log(employeeData);

  useEffect(() => {
    getSuperadmin();
  }, [isSuperadmin]);

  useEffect(() => {
    getEmployee();
  }, [isEmployee, isReload]);

  if (loading) {
    return (
      <div className="w-full h-[100vh] flex justify-center items-center">
        <CircularProgress size={40} />
      </div>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Landing />} />
          <Route path="/" element={<Layout />}>
            <Route path="employee/dashboard" element={<EmployeeDashboard />} />
            <Route
              path="employee/my-documents"
              element={<EmployeeDocuments />}
            />
            <Route
              path="employee/hr/policies"
              element={<EmployeeHRDocument />}
            />
            <Route path="employee/tickets" element={<EmployeeTickets />} />
            <Route
              path="superadmin/dashboard"
              element={<SuperadminDashboard />}
            />
            <Route path="superadmin/admins/add" element={<AddAdmin />} />
            <Route path="superadmin/employees" element={<AllEmployees />} />
            <Route
              path="superadmin/reset/password"
              element={<SAResetPassword />}
            />
            <Route
              path="superadmin/employees/onboarding"
              element={<SAOnboardingEmployee />}
            />
            <Route
              path="superadmin/employee/settings/role/:userId"
              element={<RoleSettings />}
            />
            <Route path="admin/onboarding" element={<OnboardingEmployee />} />
            <Route
              path="admin/salary-structure"
              element={<SalaryStructure />}
            />
            <Route
              path="admin/comp-off/records/all"
              element={<CompOffRecordAll />}
            />
            <Route
              path="admin/letter/template/add"
              element={<AddAndEditLetter />}
            />
            <Route
              path="admin/letter/template/edit/:templateId"
              element={<EditTemplate />}
            />
            <Route
              path="admin/letter/template/get/all"
              element={<AllSavedTemplates />}
            />
            <Route
              path="admin/comp-off/single/record/:recordId"
              element={<SingleCompOffRecord />}
            />
            <Route
              path="admin/project/management"
              element={<ProjectAssign />}
            />
            <Route
              path="admin/project/management/manager"
              element={<ManagerProjects />}
            />
            <Route
              path="admin/get/single/project/:projectId"
              element={<SingleProjectPage />}
            />
            <Route
              path="admin/get/single/project/manager/:projectId"
              element={<SingleProjectPageManager />}
            />
            <Route
              path="admin/onboarded-employees"
              element={<OnboardedEmployees />}
            />
            <Route
              path="admin/onboarded-employees/edit/:userId"
              element={<EditOnboardingEmployee />}
            />
            <Route path="admin/team" element={<TeamMembers />} />
            <Route path="admin/leave" element={<LeaveManagement />} />
            <Route
              path="admin/leave/applications/all"
              element={<AdminLeaveApplications />}
            />
            <Route
              path="admin/leave/application/:leaveId"
              element={<LeaveApproval />}
            />
            <Route
              path="admin/attendance/request/:attendanceId"
              element={<AttendanceRequest />}
            />
            <Route
              path="admin/team/member/:userId"
              element={<MemberProfile />}
            />
            <Route
              path="admin/company/goal/management"
              element={<CompanyGoalManagement />}
            />
            <Route
              path="admin/company/policy/management"
              element={<PolicyManagement />}
            />
            <Route
              path="admin/employee/goal/settings/:userId"
              element={<EmployeeGoalSettings />}
            />
            <Route
              path="admin/employee/management"
              element={<EmployeeManagement />}
            />
            <Route
              path="admin/notification/management"
              element={<NotificationManagement />}
            />
            <Route
              path="admin/employee/hr/documents/management/:userId"
              element={<EmployeeHrDocumentManagement />}
            />
            <Route
              path="admin/ticket/management"
              element={<TicketManagement />}
            />
            <Route path="admin/all/attendance" element={<AllAttedance />} />
            <Route
              path="admin/talent/aquisation"
              element={<TalentAquisation />}
            />
            <Route
              path="admin/talent/aquisation/single/hiring/request/:reqId"
              element={<TASingleHiringReq />}
            />
            <Route
              path="admin/hiring/req/single/request/:reqId"
              element={<SingleHiringReqManager />}
            />
            <Route path="admin/hiring/options" element={<HiringReqOptions />} />
            <Route
              path="admin/hiring/req/shortlisted/applicants"
              element={<ApplicantListManager />}
            />
            <Route path="admin/new/request/hiring" element={<NewHiringReq />} />
            <Route
              path="admin/manager/request/hiring/single/request/:reqId"
              element={<NewHiringReq />}
            />
            <Route
              path="admin/talent/aquisation/single/job/applicant/:applicantId"
              element={<SingleJobApplicant />}
            />
            <Route
              path="admin/talent/aquisation/final/discussion/shortlisted/applicants"
              element={<FinalRoundShortlisted />}
            />
            <Route
              path="admin/hiring/req/single/job/applicant/:applicantId"
              element={<SingleJobApplicantManager />}
            />
            <Route path="admin/all/request/hiring" element={<AllHiringReq />} />
            <Route
              path="admin/all/talent/aquisition/hiring/request/all"
              element={<TAHiringReqAll />}
            />
            <Route
              path="admin/payslip/management"
              element={<PayslipManagement />}
            />
            <Route
              path="admin/employee/single/:userId"
              element={<SingleEmployee />}
            />
            <Route
              path="admin/company/settings"
              element={<CompanySettings />}
            />
            <Route path="admin/letter/generate" element={<LetterGenerate />} />
            <Route
              path="admin/employee/edit/details/:userId"
              element={<EditEmployee />}
            />
            <Route
              path="admin/letter/generate/table/letter/:letterName"
              element={<OfferLetter />}
            />
            <Route
              path="admin/letter/generate/all/text/letter/:letterName"
              element={<TextLetterGenerate />}
            />
            <Route path="admin/letter/history" element={<LetterHistory />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="employee/attendance" element={<Attendance />} />
            <Route path="employee/leave" element={<LeaveApplications />} />
            <Route path="employee/salary" element={<EmployeeSalary />} />
            <Route path="get/employee/:userId" element={<OneEmployee />} />
            <Route path="notifications" element={<Notification />} />
            <Route
              path="leave/application/:leaveId"
              element={<MyLeaveApplication />}
            />
            <Route
              path="single/comp-off/record/:recordId"
              element={<SingleCompOffRecordEmployee />}
            />
          </Route>
          <Route path="/employee/signin" element={<EmployeeSignin />} />
          <Route
            path="/employee/forgot/password"
            element={<EmployeeForgotPassword />}
          />
          <Route path="/company/signup" element={<CompanySignup />} />
          <Route path="/superadmin/signin" element={<SuperadminSignIn />} />
          <Route
            path="/employee/onboarding/form"
            element={<EmpoloyeeOnboardingForm />}
          />
        </Routes>
      </BrowserRouter>
    </LocalizationProvider>
  );
}

export default App;
